import React from "react";
import { Route, Routes } from "react-router-dom";
import Layout from "../Components/Layout/Body/index";
import { LandingPage } from "../Pages/LandingPage";
import PrivacyPolicy from "../Pages/PrivacyPolicy";
import TermsAndConditions from "../Pages/TermsAndConditions";

const RoutePath = ({ isDarkTheme }) => {
  return (
    <div className="App">
      <Routes>
        {/* Public Routes without Layout (no header/menu) */}
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />

        {/* Routes with Layout (header/menu included) */}
        <Route element={<Layout isDarkTheme={isDarkTheme} />}>
          <Route path="/" element={<LandingPage />} />
        </Route>
      </Routes>
    </div>
  );
};
export default RoutePath;
